import { useAbmContext } from "../../../../views/abm/useAbmComponent";
import { ActionButton } from "../../../helpers";
import { EditIcon } from "../../../icons";

export const IndicadoresActividad = ({params}) => {
  const { setShowIndicadoresActividad } = useAbmContext();

  const handleClick = () => {
    setShowIndicadoresActividad(params);
  };

  return (
    <ActionButton
      enabled={true}
      Icon={EditIcon}
      onClick={handleClick}
    />
  );
};
